export default () => {
  const toggles = document.querySelectorAll(".toggle");
  const menu = document.querySelector(".nav-mobile");

  if (!toggles || !menu) {
    return;
  }

  let active = false;

  toggles.forEach((toggle) => {
    toggle.addEventListener("click", () => {
      if (active) {
        open();
      } else {
        close();
      }
    });
  });

  function open() {
    menu.classList.remove("active");
    active = false;
  }

  function close() {
    menu.classList.add("active");
    active = true;
  }

  function findAncestor(el, cls) {
    while ((el = el.parentElement) && !el.classList.contains(cls));
    return el;
  }

  const hash = window.location.hash;
  if (hash) {
    const itemsCloseBtn = document.querySelector(".items-close-btn");
    const element = document.getElementById(hash.replace("#", ""));
    const links = document.querySelectorAll(`a[href$='${hash.replace("#", "")}']`);

    if (links && links.length > 0 && links.length > 2) {
      links[links.length - 1].classList.add("font-bold");
      links[links.length - 1].classList.add("link-dot");
      findAncestor(links[links.length - 1], "hover-bg").classList.add("active-hover");
    }

    if (itemsCloseBtn) {
      itemsCloseBtn.addEventListener("click", function () {
        links.forEach((link) => {
          link.classList.remove("font-bold");
          link.classList.remove("link-dot");
        });

        document.querySelectorAll(".item-hidden").forEach((item) => {
          item.classList.remove("active");
        });
        itemsCloseBtn.classList.add("hidden");
        itemsCloseBtn.classList.remove("active");
      });

      if (element) {
        element.classList.add("active");
        itemsCloseBtn.classList.add("active");
        itemsCloseBtn.classList.remove("hidden");
      }
    }
  }

  const sideNav = document.querySelector(".slide-navigation");
  // const heroImage = document.querySelector(".hero-image");
  // heroImage.classList.add("zoom");
  // setTimeout(function () {
  //   heroImage.classList.remove("zoom");
  // }, 5000);

  const isFrontPage = document.querySelector(".front-page");
  const offset = isFrontPage ? 320 : 200;

  var onWindowScroll = debounce(function () {
    if (window.pageYOffset > offset) {
      sideNav.classList.add("blue");
    } else {
      sideNav.classList.remove("blue");
    }
  }, 30);

  function debounce(func, wait, immediate) {
    var timeout;
    return function () {
      var context = this,
        args = arguments;
      var later = function () {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };
      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  }

  if (sideNav) {
    onWindowScroll();
    window.addEventListener("scroll", onWindowScroll);
  }
};
